<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../../../../components/widgets/loader";
import Forms from "../../../../mixins/Forms";
import LoadingScreen from "../../../../components/LoadingScreen.vue";

import axios from 'axios';

/**
 * View ticket templates component
 */
export default {
    page: {
        title: "All Ticket Templates",
        meta: [{ name: "description", content: appConfig.description }]
    },
    mixins: [Forms],
    components: { Layout, PageHeader, Loader, LoadingScreen },
    data() {
        return {
            title: "All Ticket Templates",
            items: [
                {
                    text: "Settings",
                    href: "#"
                },
                {
                    text: "All Ticket Templates",
                    active: true
                }
            ],

            isDeleting: false,
            isLoading: false,
            ticketTemplates: null,
            serverErrors: []
        };
    },
    methods: {
        loadTicketTemplates() {
            let vm = this;
            vm.isLoading = true;
            axios.get(API_BASE + '/ticket-templates/').then(r => {
                vm.isLoading = false;
                vm.ticketTemplates = r.data;
            }).catch(e => {
                console.log(e);
                vm.isLoading = false;
                vm.setErrors(e);
            });
        },

        attemptDelete(templateId) {
            let vm = this;
            swal({
                title: "Are you sure you want to delete this template?",
                text: "This cannot be undone.",
                icon: "warning",
                buttons: {
                    cancel: true,
                    confirm: "Delete",
                },
                dangerMode: true,
            }).then((shouldDelete) => {
                if (shouldDelete) {
                    vm.delete(templateId);
                }
            });
        },

        delete(templateId) {
            let vm = this;
            vm.isDeleting = true;
            axios.delete(API_BASE + '/ticket-templates/' + templateId).then(r => {
                vm.isDeleting = false;
                vm.loadTicketTemplates();
                this.$notify.success({
                    title: "Success!",
                    message: "Template deleted successfully",
                });
            }).catch(e => {
                console.log(e);
                vm.isDeleting = false;
                vm.setErrors(e);
            }); 
        }
    },
    created() {
        this.loadTicketTemplates();
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <errors :error-list="serverErrors"></errors>

        <loading-screen :is-loading="isDeleting"></loading-screen>

        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div v-if="isLoading" class="text-center">
                            <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
                        </div>

                        <div v-if="!isLoading" class="table-responsive mb-0">
                            <table class="table mb-0 table-centered">
                                <thead class="thead-light">
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="template in ticketTemplates">
                                        <th scope="row">{{ template.id }}</th>
                                        <td>{{ template.name }}</td>
                                        <td class="text-right">
                                            <!-- Button trigger modal -->
                                            <button type="button" class="btn btn-itg btn-sm"
                                                @click="$router.push('/settings/ticket-templates/' + template.id + '/edit')">
                                                Edit
                                            </button>

                                            <button type="button" class="btn btn-itg-dark btn-sm ml-2"
                                                @click="attemptDelete(template.id)">
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                    <tr v-if="ticketTemplates.length === 0">
                                        <th scope="row" colspan="3">
                                            <span class="text-danger">No results</span>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>

                <a href="#" class="btn btn-itg-dark"
                    @click.prevent="$router.push('/settings/ticket-templates/create')">Create
                    Template
                </a>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>
